(function variantSwitcher() {

  const productCache = {};

  const fetchProductData = async (handle) => {
    if (productCache[handle]) return productCache[handle];
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error(`Fetch failed for ${handle}`);
      const data = await res.json();
      productCache[handle] = data;
      return data;
    } catch (e) {
      console.warn("fetchProductData error:", e);
      return null;
    }
  };

  const updateProductCard = (productCard, variant, handle, trigger = "init") => {
    if (!productCard || !variant) return;

    const mainImg = productCard.querySelector(".boost-sd__product-image-img--main");
    const hoverImg = productCard.querySelector(".boost-sd__product-image-img--second");
    const productLink = productCard.querySelector(".boost-sd__product-link");
    const buyNowBtn = productCard.querySelector(".boost-sd__button--select-option");

    if (variant.featured_image?.src) {
      const base = variant.featured_image.src;
      // Check if the base URL already contains a query string
      const separator = base.includes('?') ? '&' : '?';
      const img700 = `${base}${separator}width=700`;
      const srcsetMain = `${base}${separator}width=200 200w, ${base}${separator}width=400 400w, ${base}${separator}width=700 700w`;
      const srcsetHover = `${base}${separator}width=400 400w, ${base}${separator}width=700 700w`;
      if (mainImg) { mainImg.src = img700; mainImg.srcset = srcsetMain; }
      if (hoverImg) { hoverImg.src = img700; hoverImg.srcset = srcsetHover; }
    }

    if (productLink) {
      const baseUrl = productLink.href.split("?")[0];
      const newUrl = `${baseUrl}?variant=${variant.id}`;
      productLink.href = newUrl;
      productCard.dataset.variantUrl = newUrl;
    }

    if (buyNowBtn) buyNowBtn.dataset.variantid = variant.id;
    productCard.dataset.currentVariantId = variant.id;

    // Also update parent .boost-sd__product-item
    const parentCard = productCard.closest(".boost-sd__product-item");
    if (parentCard) parentCard.dataset.currentVariantId = variant.id;
  };

  const initFirstSwatches = async () => {
    const allCards = document.querySelectorAll("[data-product-handle]");
    if (!allCards.length) return;

    for (const card of allCards) {
      const handle = card.dataset.productHandle;
      if (!handle) continue;
      const activeLabel = card.querySelector(".boost-sd__radio-label.active") ||
                          card.querySelector(".boost-sd__radio-label");
      if (!activeLabel) continue;

      const inputId = activeLabel.getAttribute("for");
      const input = inputId ? document.getElementById(inputId) : null;
      if (!input) continue;

      const picked = (input.value || "").trim().toLowerCase();
      const data = await fetchProductData(handle);
      if (!data?.variants?.length) continue;

      const match = data.variants.find(v =>
        v.option1?.toLowerCase() === picked ||
        v.option2?.toLowerCase() === picked ||
        v.option3?.toLowerCase() === picked
      ) || data.variants[0];

      activeLabel.classList.add("active");
      activeLabel.setAttribute("aria-pressed", "true");
      updateProductCard(card, match, handle);
    }
  };

  const resolveVariantIdForCard = async (cardEl, handle) => {
    const activeLabel = cardEl.querySelector(".boost-sd__radio-label.active");
    if (activeLabel) {
      const inputId = activeLabel.getAttribute("for");
      const input = inputId ? document.getElementById(inputId) : null;
      const val = (input?.value || "").trim().toLowerCase();
      if (val) {
        const data = await fetchProductData(handle);
        const match = data?.variants?.find(v =>
          v.option1?.toLowerCase() === val ||
          v.option2?.toLowerCase() === val ||
          v.option3?.toLowerCase() === val
        );
        if (match) return match.id;
      }
    }

    const cardBlock = cardEl.querySelector("[data-product-handle]");
    const idFromCard = cardBlock?.dataset.currentVariantId;
    if (idFromCard) return idFromCard;

    const data = await fetchProductData(handle);
    if (data?.variants?.length)
      return (data.variants.find(v => v.available)?.id) || data.variants[0].id;

    return null;
  };

  const overrideBuyNowButtons = async () => {
    const productItems = document.querySelectorAll(".boost-sd__product-item");

    for (const item of productItems) {
      const handle = item.querySelector("[data-product-handle]")?.dataset.productHandle;
      if (!handle) continue;

      const data = await fetchProductData(handle);
      if (!data?.variants?.length || data.variants.length <= 1) continue;

      const btn = item.querySelector(
        '.boost-sd__cta-wrapper-sublayout-8--show-not-hover button.boost-sd__button--select-option[aria-label="Select options"]'
      );
      if (!btn) continue;

      const textEl = btn.querySelector(".boost-sd__button-text, .boost-sd__cta-button-text");
      if (textEl) textEl.textContent = "Add to Cart"; else btn.textContent = "Add to Cart";
      btn.setAttribute("aria-label", "Add to Cart");

      if (btn.dataset.cwBound === "1") continue;
      btn.dataset.cwBound = "1";

      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const variantId = await resolveVariantIdForCard(item, handle);
        if (!variantId) {
          console.warn(`[variantSwitcher] ${handle}: no variantId resolved`);
          return;
        }

        const label = btn.querySelector(".boost-sd__button-text, .boost-sd__cta-button-text");
        btn.disabled = true;
        if (label) label.textContent = "Adding…"; else btn.textContent = "Adding…";

        try {
          if (window.eHS && typeof window.eHS.addToCart === "function") {
            await window.eHS.addToCart(variantId, 1);
          } else {
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            });
            if (!res.ok) throw new Error(`Cart add failed (${res.status})`);
          }

          if (label) label.textContent = "Added!"; else btn.textContent = "Added!";
        } catch (err) {
          console.error(`[variantSwitcher] add error for ${handle}:`, err);
          if (label) label.textContent = "Error — try again";
          else btn.textContent = "Error — try again";
        } finally {
          setTimeout(() => {
            btn.disabled = false;
            if (label) label.textContent = "Add to Cart"; else btn.textContent = "Add to Cart";
          }, 1500);
        }
      });
    }
  };

  const runSequence = async () => {
    await initFirstSwatches();
    setTimeout(overrideBuyNowButtons, 20);
  };

  let tries = 0;
  const waitForBoost = setInterval(() => {
    const cards = document.querySelectorAll("[data-product-handle]");
    const isPDP = document.querySelector(".product, .product-single, .product-main");
    tries++;

    if (cards.length > 0 || isPDP) {
      clearInterval(waitForBoost);
      runSequence();
    }

    if (tries > 33) {
      clearInterval(waitForBoost);
      console.log("[variantSwitcher] No product elements found — stopped after 10s.");
    }
  }, 300);

  document.addEventListener("boost-pfs-filter-rendered", () => runSequence());

  document.addEventListener("click", async (e) => {
    const label = e.target.closest(".boost-sd__radio-label");
    const image = e.target.closest(".boost-sd__product-image-img");

    if (label) {
      const inputId = label.getAttribute("for");
      const input = inputId ? document.getElementById(inputId) : null;
      if (!input) return;

      const productCard = label.closest("[data-product-handle]");
      const handle = productCard?.dataset.productHandle;
      if (!handle) return;

      const clickedColor = (input.value || "").trim().toLowerCase();
      const productData = await fetchProductData(handle);
      if (!productData?.variants?.length) return;

      const variant = productData.variants.find(v =>
        v.option1?.toLowerCase() === clickedColor ||
        v.option2?.toLowerCase() === clickedColor ||
        v.option3?.toLowerCase() === clickedColor
      );
      if (!variant) return;

      productCard.querySelectorAll(".boost-sd__radio-label").forEach(lbl => {
        lbl.classList.remove("active");
        lbl.setAttribute("aria-pressed", "false");
      });
      label.classList.add("active");
      label.setAttribute("aria-pressed", "true");
      updateProductCard(productCard, variant, handle, "click");
    }

    if (image) {
      const productCard = image.closest("[data-product-handle]");
      const variantUrl = productCard?.dataset.variantUrl;
      if (variantUrl) {
        e.preventDefault();
        window.location.href = variantUrl;
      }
    }
  });

})();
